module.exports = __webpack_public_path__ + "static/media/logo.feb42631.png";